export const enum INCENTIVE_CAMPAIGN {
  FLORA_SECTION = 'incentivo-de-natal-2024',
}
